function fn_part_form() {
    $(document).on('click', '.form .legend.optional', function () {
        $(this).find(".icon").toggleClass("active").parent().next().stop(true).slideToggle(500).toggleClass("active");
        
        if($(this).hasClass('triggerX')) {
            $(this).find('[type="checkbox"]').prop('checked', $(this).find(".icon").hasClass('active'));
        }
    });
}